import React from 'react';

interface HeroImageProps {
  src: string;
  alt: string;
  isLoaded: boolean;
  onLoad: () => void;
}

export function HeroImage({ src, alt, isLoaded, onLoad }: HeroImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={`
        w-full h-auto object-contain transition-opacity duration-500
        px-4 sm:px-6 lg:px-8
        max-h-[300px] lg:max-h-[600px]
        ${isLoaded ? 'opacity-100' : 'opacity-0'}
      `}
      style={{
        objectFit: 'contain',
        objectPosition: 'center'
      }}
      loading="eager"
      onLoad={onLoad}
    />
  );
}